let ymqFound = false;

// Inutilisé sur le site, décode la chaine de caractère et télécharge un fichier GoogleMapsCapture.png
function getFileFromBase64(string64, fileName) {
  const trimmedString = string64.replace('data:image/octet-stream;base64,', '');
  const imageContent = atob(trimmedString);
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);
  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }
  const type = 'image/jpeg';
  const blob = new Blob([buffer], { type });
  const fichier = new File([blob], fileName, { lastModified: new Date().getTime(), type });
  var a = document.createElement('a');
  a.download = 'GoogleMapsCapture.png';
  a.href = window.URL.createObjectURL(fichier);
  a.click();
} //Fin decode

function changeSize(w,h){
    document.getElementById("lamap").setAttribute('style', `width:${w}px;height:${h}px;position:relative;overflow:hidden;display: block;unicode-bidi: isolate;`)
}

async function takeScreenshot(){  
  console.log("goscreen")
  //const mapCanvas = document.getElementById("lamap")?.querySelector(".gm-style canvas");
  const mapElement = document.getElementById("lamap")?.querySelector(".gm-style")?.firstChild;
  console.log(window.getComputedStyle(document.getElementById("lamap")).width)
  // ⚡ Create completely isolated iframe
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.left = '-9999px';
  iframe.style.width = window.getComputedStyle(document.getElementById("lamap")).width;
  iframe.style.height = window.getComputedStyle(document.getElementById("lamap")).height;
  document.body.appendChild(iframe);
  
  // Clone map into iframe (isolated from Shopify DOM)
  const iframeDoc = iframe.contentDocument;
  iframeDoc.body.appendChild(mapElement.cloneNode(true));
  
  // Wait a tick for iframe to render
  await new Promise(resolve => setTimeout(resolve, 100));
  
  html2canvas(iframeDoc.body.firstChild, {
    scale : 1,
    useCORS: true,
    allowTaint: false,
    logging: false,
      removeContainer: true,
    backgroundColor: null,
    foreignObjectRendering: false, // Disable for better Shopify compatibility
  imageTimeout: 5000, // Don't wait forever for CDN images
  //onclone: function(clonedDoc) {
  //  // Remove app scripts and tracking pixels from the clone
  //  const scripts = clonedDoc.querySelectorAll('script, iframe, [data-shopify]');
  //  scripts.forEach(script => script.remove());
  //},
  onclone: function(clonedDoc) {
    console.log("onclone")
        // Remove unnecessary elements from clone
        const toRemove = clonedDoc.querySelectorAll('script, iframe, [data-shopify]');
        toRemove.forEach(el => el.remove());
      },
      //ignoreElements: function(element) {
      //  // Simplified ignore list
      //  return element.nodeName === 'IFRAME' || 
      //         element.nodeName === 'SCRIPT';
      //}
    //});

    ignoreElements: function(element) {
    // Ignore custom elements that have JavaScript classes
    const customElements = [
      'localization-form',
      'details-modal', 
      'predictive-search',
      'quantity-input',
      'product-form',
      'details-disclosure',
      'share-button',
      'modal-dialog',
      element.nodeName === 'IFRAME',
      'product-modal'
    ];
    
    return customElements.includes(element.tagName.toLowerCase());
  },
  })
  .then((canvas) => {
    console.log("gothen")
     //document.body.appendChild(canvas)
       var image = canvas
         .toDataURL("image/jpg")
         .replace("image/jpg", "image/octet-stream");
         console.log(image)
         document.querySelector('input[name="properties[_inputimagegooglemaps]"]').value = image
         iframe.remove();
  })
  .catch((error) => console.log(error))

}

// Écouter les changements de sélecteur de variante
// document.addEventListener('DOMContentLoaded', function() {
//   document.addEventListener('variant:changed', function(event) {
//   console.log("chadfuaeidzabdi")
// });
//    const variantSelector = document.querySelector("#Option-template--27245207978321__main-0");
//    console.log("jesaispastrop")
//    variantSelector.addEventListener("change", function(event) {
//      console.log("change")
//      console.log(event)
//      //console.log(event.target.options[event.selectedIndex].text)
//      console.log(event.target.value)
//        const variantSelected = event.target.value
//        //const variantSelected = event.options[event.selectedIndex].text;
    
//        // Votre code personnalisé ici
//        console.log('Variante sélectionnée:', variantSelected);
    
//      })
// })
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}


async function waitForOptions(){
  try{
  console.log('jattendoptions');
  var leSelect = await waitForElm( "#Option-template--26373035360520__featured_product_dPag7n-1" );
  var lautreSelect = await waitForElm( "#Option-template--26373035360520__featured_product_dPag7n-0" );
  //ymqFound = true
  console.log("jaitrouvoptions");
  resizeMap()
  checkCadre()
  //document.getElementById("Option-template--26373035360520__featured_product_dPag7n-0").addEventListener("change", () => {
  //  console.log("event0")
  //  resizeMap();
  //  saveMap();
  //})
  //document.getElementById("Option-template--26373035360520__featured_product_dPag7n-1").addEventListener("change", () => {
  //  console.log("event1")
  //  resizeMap();
  //  saveMap();
  //})
  document.addEventListener("change", (e) => {
  if (e.target.id === "Option-template--26373035360520__featured_product_dPag7n-0") {
    resizeMap();
    saveMap();
  }
  if (e.target.id === "Option-template--26373035360520__featured_product_dPag7n-1") {
    resizeMap();
    saveMap();
  }
  if (e.target.id === "Option-template--26373035360520__featured_product_dPag7n-2") {
    checkCadre();
  }
  repositionGmap()

  
});

  }
  catch(error){
    console.log(error)
  }
  //let w = 5*( leSelect.options[ leSelect.selectedIndex ].value.split('x')[0] )
  //let h = 5*( leSelect.options[ leSelect.selectedIndex ].value.split('x')[1].split(" ")[0] )
  //let vertical = lautreSelect.options[lautreSelect.selectedIndex].value == "Vertical"
  //let ratio = h/w
  //const windowwidth  = window.innerWidth || document.documentElement.clientWidth || 
  //document.body.clientWidth;
  //if(vertical)
  //{
  // w= windowwidth>749 ? windowwidth*0.25 : windowwidth*0.5
  // h = w*ratio
  //}
  //else
  //{
  // h= windowwidth>749 ? windowwidth*0.25 : windowwidth*0.5
  // w = h*ratio
  //}
  // document.getElementById("lamap").setAttribute('style', `width:${w}px;height:${h}px;position:relative;overflow:hidden;display: block;unicode-bidi: isolate;`)
  // document.getElementById("map-container").style.width = `${20+w}px`
  // document.getElementById("map-container").style.height = `${20+h}px`

}


async function waitForYMQ(){
  try{
  console.log('jattendymq')
  var leSelect = await waitForElm( "#ymq-attrib-ymq-variant-1" );
  var lautreSelect = await waitForElm( "#ymq-attrib-ymq-variant-0" );
  ymqFound = true;
  console.log("jaitrouvymq");
  console.log(ymqFound)
  resizeMap();
  checkCadre()
  document.getElementById("ymq-attrib-ymq-variant-0").addEventListener("change", () => {
    resizeMap();
    saveMap();
  })
  document.getElementById("ymq-attrib-ymq-variant-1").addEventListener("change", () => {
    resizeMap();
    saveMap();
  })
  document.getElementById("ymq-attrib-ymq-variant-2").addEventListener("change", () => {
    checkCadre();
  })
  repositionGmap()
  
  }
  catch(error){
    console.log(error)
  }
  //let w = 5*( leSelect.options[ leSelect.selectedIndex ].value.split('x')[0] )
  //let h = 5*( leSelect.options[ leSelect.selectedIndex ].value.split('x')[1].split(" ")[0] )
  //let vertical = lautreSelect.options[lautreSelect.selectedIndex].value == "Vertical"
  //let ratio = h/w
  //const windowwidth  = window.innerWidth || document.documentElement.clientWidth || 
  //document.body.clientWidth;
  //if(vertical)
  //{
  // w= windowwidth>749 ? windowwidth*0.25 : windowwidth*0.5
  // h = w*ratio
  //}
  //else
  //{
  // h= windowwidth>749 ? windowwidth*0.25 : windowwidth*0.5
  // w = h*ratio
  //}
  // document.getElementById("lamap").setAttribute('style', `width:${w}px;height:${h}px;position:relative;overflow:hidden;display: block;unicode-bidi: isolate;`)
  // document.getElementById("map-container").style.width = `${20+w}px`
  // document.getElementById("map-container").style.height = `${20+h}px`
}

window.addEventListener("resize", () => {
  resizeMap()
  repositionGmap()
  // if(ymqFound === true)
  // {
  //   waitForYMQ();
  // }else{
  //   waitForOptions();
  //}
})

// const mediaQuery = window.matchMedia('(orientation: portrait)');
// mediaQuery.addEventListener('change', (e) => {
//   resizeMap()
//   repositionGmap()
// });

// document.addEventListener('DOMContentLoaded', () => {
//   waitForYMQ()
//   if (typeof subscribe !== 'undefined') {
//     subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
//       console.log(event.data.target.parentNode.id)
//       console.log("eventgo")
//       if(event.data.target.parentNode.id == 'ymq-attrib-ymq-variant-1')
//       {
//         let w = 5*event.data.target.value.split('x')[0]
//         let h = 5*event.data.target.value.split('x')[1].split(" ")[0]
//         let ratio = h/w
//         const windowwidth  = window.innerWidth || document.documentElement.clientWidth || 
//       document.body.clientWidth;
//         let vertical = document.getElementById("ymq-attrib-ymq-variant-0").options[document.getElementById("ymq-attrib-ymq-variant-0").selectedIndex].value == "Vertical"  
//         if(vertical)
//         {
//           w= windowwidth*0.3
//           h = w*ratio
//         }
//         else
//         {
//           h= windowwidth*0.3
//           w = w*ratio
//         }
//         //document.getElementById("map-container").setAttribute('style', `width:${w}px;height:${h}px`)
//         document.getElementById("lamap").setAttribute('style', `width:${w}px;height:${h}px;position:relative;overflow:hidden;display: block;unicode-bidi: isolate;`)
//         document.getElementById("map-container").style.width = `${20+w}px`
//         document.getElementById("map-container").style.height = `${20+h}px`
//         // animationName only returns the name
//         if( document.getElementById("position-saved").style.animationName == 'fadeInFromNone1' ){
//         document.getElementById("position-saved").style.animation = 'fadeInFromNone2 2s linear'
//         } else {
//         document.getElementById("position-saved").style.animation = 'fadeInFromNone1 2s linear'
//         }
//         document.querySelector('input[name="properties[_inputcoordsgooglemaps]"]').value = getCoordinatesAndZoomAndSize(map)
//         document.querySelector('input[name="properties[_inputimagegooglemaps]"]').value = takeScreenshot()

//       }
//     });
//   }
// });

function checkCadre(){
  let select2id = "non";
  if(ymqFound == true){
    select2id = "ymq-attrib-ymq-variant-2"
  }else{
    select2id = "Option-template--26373035360520__featured_product_dPag7n-2"
  }
    const selectCadre = document.getElementById(select2id)
  if(selectCadre.options[selectCadre.selectedIndex].value == "Sans cadre" ){
    document.getElementById("map-container").classList.add("map-container-nocadre");
  }else{
    document.getElementById("map-container").classList.remove("map-container-nocadre");
  }
}

function resizeMap(){
  let select0id ="non";
  let select1id ="non";
  if(ymqFound == true)
  //if (document.getElementById('ymq-attrib-ymq-variant-0'))
  {
    select0id = "ymq-attrib-ymq-variant-0"
    select1id = "ymq-attrib-ymq-variant-1"
  }else{
    select0id = "Option-template--26373035360520__featured_product_dPag7n-0"
    select1id = "Option-template--26373035360520__featured_product_dPag7n-1"
  }
    const selectVertical = document.getElementById(select0id)
    const selectSize = document.getElementById(select1id)
  let w = 5*selectSize.options[selectSize.selectedIndex].value.split('x')[0]
  let h = 5*selectSize.options[selectSize.selectedIndex].value.split('x')[1].split(" ")[0]
  let ratio = h/w
  const windowwidth  = window.innerWidth || document.documentElement.clientWidth || 
document.body.clientWidth;
  let vertical = selectVertical.options[selectVertical.selectedIndex].value == "Vertical"  
  if(vertical)
  {
    w= windowwidth>749 ? windowwidth*0.25 : windowwidth*0.6
    h = w*ratio
  }
  else
  {
    h= windowwidth>749 ? windowwidth*0.25 : windowwidth*0.6
    w = h*ratio
  }
  if(windowwidth <= 749 && h>w)
  {
    h*=1.2;
    w*=1.2;
  }
  if(Math.abs(w - h) < 3)
  {
    h *=1.4;
    w *=1.4;
  }
  //document.getElementById("map-container").setAttribute('style', `width:${w}px;height:${h}px`)
  document.getElementById("lamap").setAttribute('style', `width:${w}px;height:${h}px;position:relative;overflow:hidden;display: block;unicode-bidi: isolate;`)
  document.getElementById("map-container").style.width = `${20+w}px`
  document.getElementById("map-container").style.height = `${20+h}px`
  document.getElementById("gmap-text-input-doublecontainer").style.width = `${20+w}px`
  document.getElementById("gmap-text-input").style.width = `${w-90}px`
  console.log(w)
  console.log(h)
}

function saveMap(){
  // animationName only returns the name
  if( document.getElementById("position-saved").style.animationName == 'fadeInFromNone1' )
  {
  document.getElementById("position-saved").style.animation = 'fadeInFromNone2 2s linear'
  } else {
  document.getElementById("position-saved").style.animation = 'fadeInFromNone1 2s linear'
  }
  document.querySelector('input[name="properties[_inputcoordsgooglemaps]"]').value = getCoordinatesAndZoomAndSize(map)
  //document.querySelector('input[name="properties[_inputimagegooglemaps]"]').value = takeScreenshot()
}

function repositionGmap(){
  const windowwidth  = window.innerWidth || document.documentElement.clientWidth || 
document.body.clientWidth;
if(windowwidth < 750){
  if(ymqFound == true){
    const productInfoTemplate = document.getElementById("ymq-box")
    productInfoTemplate.insertBefore(document.getElementById("gmap-whole-container"),document.getElementById("option-box-3"))
  }else{
    const productInfoTemplate = document.getElementById("ProductInfo-template--26373035360520__featured_product_dPag7n")
    productInfoTemplate.insertBefore(document.getElementById("gmap-whole-container"),document.getElementById("Quantity-Form-template--26373035360520__featured_product_dPag7n"))
  }
}else{
  document.querySelector(".product__media-wrapper").appendChild(document.getElementById("gmap-whole-container"))
  }
}

document.addEventListener('DOMContentLoaded', async function() {
  waitForYMQ()
  waitForOptions()


  // console.log("jexiste")
  // console.log(document.getElementById("ymq-attrib-ymq-variant-0"))
  // document.getElementById("ymq-attrib-ymq-variant-0").addEventListener("change", () => {resizeMap()})
  // document.getElementById("ymq-attrib-ymq-variant-1").addEventListener("change", () => {resizeMap()})



  //if (typeof subscribe !== 'undefined') {
  //  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
  //    console.log(event.data.target.parentNode.id)
  //    console.log("eventgo")
  //    if(event.data.target.parentNode.id == 'ymq-attrib-ymq-variant-1')
  //    {
  //      
  //    }
  //  });
  //}
});


// let productUrl = document.querySelector('[data-product-url]').dataset.productUrl;
// let sectionId = document.querySelector('[data-section-id]').dataset.sectionId;
// let variantId = document.querySelector('[data-variant-id]').dataset.variantId;

// // Récupérer le HTML mis à jour
// fetch(`${productUrl}?section_id=${sectionId}&variant=${variantId}`)
//   .then(response => response.text())
//   .then(responseText => {
//     // Traiter la réponse
//     console.log("reponseu")
//     const updatedHtml = new DOMParser().parseFromString(responseText, 'text/html');
//     // Mettre à jour votre DOM selon vos besoins
//   });

   // e.options[e.selectedIndex].text;

function onMapIdle(){
if (document.readyState === "complete" || document.readyState === "loaded") {
        takeScreenshot()
        document.querySelector('input[name="properties[_inputcoordsgooglemaps]"]').value = getCoordinatesAndZoomAndSize(map)
        
        if( document.getElementById("position-saved").style.animationName == 'fadeInFromNone1' ){
        document.getElementById("position-saved").style.animation = 'fadeInFromNone2 2s linear'
        } else {
        document.getElementById("position-saved").style.animation = 'fadeInFromNone1 2s linear'
        }
}
        
}

    let map;
let markers = {};
let infoWindow;

    async function initMap() {
      const { Map } = await google.maps.importLibrary("maps");
      map = new Map(document.getElementById("lamap"), {
        center: { lat: 48, lng: 2 },
        zoom: 5,
        fullscreenControl: false,
        mapTypeControl: false,
        scrollwheel: true,
        mapId: 'DEMO_MAP_ID',
      });
      map.addListener("idle", function() {
      console.log("Map moved!")
      onMapIdle()
      })
    const textInput = document.getElementById('gmap-text-input');
    const textInputButton = document.getElementById('gmap-text-input-button');
    const card = document.getElementById('gmap-text-input-card');
    //map.controls[google.maps.ControlPosition.TOP_LEFT].push(card);
    textInputButton.addEventListener('click', () => {
        findPlaces(textInput.value);
    });
    textInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
            findPlaces(textInput.value);
        }
    });
    infoWindow = new google.maps.InfoWindow();
    //card.setAttribute('style','display:flex;')
}

async function findPlaces(query) {
    const { Place } = await google.maps.importLibrary("places");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    const request = {
        textQuery: query,
        fields: ['displayName', 'location', 'businessStatus'],
        includedType: '', // Restrict query to a specific type (leave blank for any).
        useStrictTypeFiltering: true,
        locationBias: map.center,
        isOpenNow: true,
        language: 'en-US',
        maxResultCount: 8,
        minRating: 1, // Specify a minimum rating.
        region: 'us',
    };
    const { places } = await Place.searchByText(request);
    if (places.length) {
        const { LatLngBounds } = await google.maps.importLibrary("core");
        const bounds = new LatLngBounds();
        // First remove all existing markers.
        for (const id in markers) {
            markers[id].map = null;
        }
        ;
        markers = {};
        // Loop through and get all the results.
        places.forEach(place => {
            //const marker = new AdvancedMarkerElement({
            //    map,
            //    position: place.location,
            //    title: place.displayName,
            //});
            //markers[place.id] = marker;
            //marker.addListener('gmp-click', () => {
            //    map.panTo(place.location);
            //    updateInfoWindow(place.displayName, place.id, marker);
            //});
            if (place.location != null) {
                bounds.extend(place.location);
            }
        });
        map.fitBounds(bounds);
                map.setZoom(14)
    }
    else {
        console.log('No results');
    }
}

// Helper function to create an info window.
async function updateInfoWindow(title, content, anchor) {
    infoWindow.setContent(content);
    infoWindow.setHeaderContent(title);
    infoWindow.open({
        map,
        anchor,
        shouldFocus: false,
    });
}


    initMap();
    
    function getCoordinatesAndZoomAndSize(map){
      const w = window.getComputedStyle(document.getElementById("lamap")).width
      const h = window.getComputedStyle(document.getElementById("lamap")).height

        const coords_and_zoom = `${map.getCenter().lat()},${map.getCenter().lng()},${map.getZoom()},${window.getComputedStyle(document.getElementById("lamap")).width},${window.getComputedStyle(document.getElementById("lamap")).height}`
        return coords_and_zoom
    }